import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { Textarea, TextareaInput } from 'aos-ui-universal'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

interface TaskDescriptionFieldProps {
    isTaskTemplate: boolean
}

export const TaskDescriptionField = ({ isTaskTemplate }: TaskDescriptionFieldProps) => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload

    return (
        <Controller
            control={control}
            name='description'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.description.label', { ns: 'tasks' })}
                    required={task.billable && !isTaskTemplate}
                    error={
                        fieldState.error
                            ? translate('form.description.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <Textarea>
                        <TextareaInput
                            value={field.value ?? ''}
                            onChangeText={(v: string) => field.onChange(v)}
                        />
                    </Textarea>
                </TaskFormField>
            )}
        />
    )
}
